import { mainlistDefault } from "../../../common/consts";
export default {
  mainlists: {
    leftA: mainlistDefault,
    leftB: mainlistDefault,
    rightA: mainlistDefault,
    rightB: mainlistDefault
  }
};